export default __webpack_public_path__ + "static/media/Sukanta_Dolai_Resume.25e3589c.pdf";